export class KYMW1105InputModel {
  public pCode: string = <string>'';										// Ｐコード
  public itemCode: string = <string>'';										// アイテムコード
}
